import type { ForgotPasswordFormType } from '../../schemas';
import { Form } from '@packages/chakra-v3';
import { Stack } from '@chakra-ui/react';

const ForgotPasswordForm = () => {
	return (
		<Stack gap={8}>
			<Form.TextInput<ForgotPasswordFormType> label={'Email'} name={'email'} />
			<Form.SubmitButton>Send Reset Email</Form.SubmitButton>
		</Stack>
	);
};

export default ForgotPasswordForm;